import React, { useState, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { Menu, Dropdown, Button, Tooltip, Avatar, Badge, Select } from "antd";
import Datetime from "../../layout/DateTime";
import { useSelector, useDispatch } from "react-redux";
import filterSmall from "../../../assets/filterIcon.svg";
import CloseIcon from "../../../assets/Close.svg";
import { PlusCircleOutlined } from "@ant-design/icons";
import { CloseCircleOutlined } from "@ant-design/icons";
import filterSmallWhite from "../../../assets/WhiteIcons/filterIconWhite.svg";

import restoreDashboardIcon from "../../../assets/restore_dashboard_icon.svg";

import edit from "../../../assets/Edit_icon.svg";
import editWhite from "../../../assets/Edit_iconWhite.svg";
import Delete from "../../../assets/Del_icon.svg";
import DeleteWhite from "../../../assets/WhiteIcons/DelWhite_icon.svg";

import SaveAsBlackIcon from "../../../assets/save_as_black_icon.svg";
import SaveAsWhiteIcon from "../../../assets/save_as_white_icon.svg";

import Share_Dashboard from "../../../assets/Share_Dashboard.svg";
import ShareDashboardWhite from "../../../assets/WhiteIcons/Share_Dashboard_white.svg";

import download from "../../../assets/Download_Icon1.svg";
import downloadWhite from "../../../assets/WhiteIcons/DownloadWhite_Icon1.svg";
import downloadPpt from "../../../assets/ppt/PPT_Icon-gray.svg";
import downloadPptWhite from "../../../assets/WhiteIcons/PPT_Icon-white.svg";
import betaBtn from "../../../assets/AIGeneratedInsights/beta_btn.svg";

import DeleteWidget from "../sectionInsight/Widget/DeleteWidget";
import ShareModal from "./share/shareModal";
import config1 from "../../../config";
import SchedulReportIcon from "../../../assets/ScheduleReportIconNew.svg";
import SchedulReportIconWhite from "../../../assets/ScheduleReportIconNewWhite.svg";
import moment from "moment";
import {
  getFilterPanelData,
  getPaneIndex,
  getCustomizedDate,
  getBrands,
  getDefaultCompBrand,
  getGlobalBrands,
  getGlobalFilterAndFilterCountObject,
  getTemplateListBasicObject,
  getTemplateListDashboardObject,
  getByDefaultProfileFilters,
  deepCopy,
  removeHiddenAndQuickFilters,
  getSimilarStaticFilter,
  callNotification,
  getFormattedBrandsForApi,
  removePrivateConversationFilters,
  removeSavedFilters,
  urlParams,
  getPinnedTemplateDetails,
  removeHiddenFromSaved,
  processQuickFilterForADCampaign,
} from "../../../redux/constants";
import {
  setFilterPanelData,
  setisFilterPanelVisible,
} from "../../../redux/actions/Filter";
import ErrorBoundary from "../../../ErrorBoundary";
import dots from "../../../assets/Dot_icon.svg";
import dotsWhite from "../../../assets/WhiteIcons/DotWhite_icon.svg";
import {
  setDeleteTemplate,
  getShareableUserData,
  getDefaultShareableUserData,
  setPdfGenerateStatus,
  setPdfModalOpen,
  setSchedulePdf,
  setIsScheduleReportOpen,
  setIsDashboardScheduleModal,
  setIsDashboardScheduleTemplate,
  setDuplicateDashboardFlag,
  setSaveDashboardModalFlag,
  setSaveEditedDashboardModalFlag,
} from "../../../redux/actions/ApiCall/apiCall";
import {
  setTemplateName,
  setIsDashboard,
  setClearTemplateData,
  setDashboardTemplateFilters,
  setGlobalFilter,
  setTicketIsModifiedDate,
  setSelectedPillInPane,
  setClearGraphData,
} from "../../../redux/actions/dashboard/Tab1";
import {
  setAddSection,
  setFooterValue,
  setIsEditTemplate,
  setSectionDetails,
} from "../../../redux/actions/section/section";
import { setTemplateDetails } from "../../../redux/actions/section/section";
import {
  setEditPanel,
  setSectionOffset,
  setSharableData,
} from "../../../redux/actions/dashboard/dashboard";
import AccountList from "../../layout/WelcomePage/Template/AccountList";
import BrandsLogicalGroup from "../../layout/WelcomePage/Template/BrandsLogicalGroup";
import ProfileSelection from "../../layout/WelcomePage/Template/ProfileSelection";
import SingleBrands from "../../layout/WelcomePage/Template/SingleBrands";
import {
  setPPTModalOpen,
  setPptTemplateData,
} from "../../../redux/actions/PPT";
import PdfModal from "./PdfModal";
import ModalAI from "./ModalAI";
import { setUpdateImpression } from "../../../redux/actions/WidgetMaker/WidgetAPI";
import ModalPpt from "./ModalPpt";
import FilterDrawer from "../../layout/Workspace/drawers/FilterDrawer";
import { setOptionHighChart } from "../../../redux/actions/HighChart";
import { getfeedbackResponse } from "../../../redux/actions/Sidebar";
import SaveAsModal from "./share/SaveAsModal";
import SaveDashboardModal from "./share/SaveDashboardModal";
import Blue_Pin from "../../../assets/Blue_Pin.svg";
import quickfiltericon from "../../../assets/quick-filters-icon.svg";
import SaveEditedDashboardModal from "./SaveEditedDashboardModal";
import { RedoOutlined } from "@ant-design/icons";
import restoreWidgetIcon from "../../../assets/restore_widget_icon.svg";
import RestoreDashboardModal from "./RestoreDashboardModal";
import CompetitorBrandLabels from "../../shared/components/CompetitorBrandLabels/CompetitorBrandLabels";
import CustomDurationCalendar from "../../layout/DateTime/customCalendar";
import { supportedBenchmarkTraceDashboardTypes } from "../../../redux/constants/enums";

const { Option } = Select;

const ScheduleReportIndex = React.lazy(() =>
  import("../../scheduleReport/Index")
);
const Header = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const config = useSelector((state) => state.apiCall.config);
  const duplicateDashboardFlag = useSelector(
    (state) => state.ApiCall.duplicateDashboardFlag
  );
  const saveDashboardModalFlag = useSelector(
    (state) => state?.ApiCall?.saveDashboardModalFlag
  );
  const saveEditedDashboardModalFlag = useSelector(
    (state) => state?.ApiCall?.saveEditedDashboardModalFlag
  );

  const [templateType, setTemplateType] = useState("custom");
  const [aggrigation, setAggrigation] = useState("avg");
  const [dashboardType, setDashboardType] = useState("custom");
  const [quickFilter, setQuickFilter] = useState("");
  const [channelList, setChannelList] = useState("");
  const [socialChannel, setSocialChannel] = useState(false);
  const [lock, setLock] = useState({
    is_brand_locked: false,
    is_date_locked: false,
  });

  const [isModalShow, setModalShow] = useState(false);
  const [searchTerm, setSearchTerm] = useState(null);

  const [isModalSaveAndShare, setIsModalSaveAndShare] = useState(false);
  const [isModalSaveAs, setIsModalSaveAs] = useState(false);
  const [isModalShare, setisModalShare] = useState(false);

  const [filterClearTrigger, setfilterClearTrigger] = useState(false);
  const [filterSearch, setfilterSearch] = useState("");
  const [modalText, setmodalText] = useState("");
  const [totalPdfWidgets, setTotalPdfWidgets] = useState(null);
  const [unsupportedPdfWidgets, setUnsupportedPdfWidgets] = useState(null);
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const isPPTModalOpen = useSelector((state) => state.PPT.isPPTModalOpen);
  const All_Share_attributes = useSelector(
    (state) => state.WidgetMaker.All_Share_attributes
  );
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  let index = getPaneIndex(panes, activeKey);
  const templateDetails = useSelector((state) => state.Section.templateDetails);
  const Section = useSelector((state) => state.Section.addSection);
  const visible = useSelector((state) => state.Filter.isFilterPanelVisible);
  const templateAccessType = panes[index].access_type;
  const selectedDate = panes[index].duration;
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const competitorBrands = useSelector(
    (state) => state.WidgetAPI.competitorBrands?.data?.result
  );
  const aggregateLoader = useSelector((state) => state.apiCall.aggregateLoader);
  const graphLoader = useSelector((state) => state.apiCall.loader); //display chart loader
  const profileLoader = useSelector((state) => state.apiCall.profileLoader);

  const sections = panes[index]?.sections;
  const isPdfModalOpen = useSelector((state) => state.ApiCall.isPdfModalOpen);
  const global_dashboard_duration = useSelector(
    (state) => state.AuthParams.global_dashboard_duration
  );
  const global_dashboard_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_brands
  );
  const global_dashboard_single_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_single_brands
  );
  const scheduleObj = useSelector((state) => state.scheduleReport.scheduleObj);
  const workspace_privileges = useSelector(
    (state) => state.ApiCall.workspace_privileges
  );
  const profileId = useSelector((state) => state.Template.profileId);
  // const userPrivileges = useSelector(
  //   (state) => state?.ApiCall?.brands?.data?.result?.privileges
  // );
  const isDashboardScheduleModal = useSelector(
    (state) => state?.ApiCall?.is_dashboard_schedule_modal
  );
  const templateData = useSelector((state) => state.ApiCall.templateData);
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const shareTemplateData = useSelector(
    (state) => state?.ApiCall?.shareTemplateData
  );
  const Allbrands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const sectionDetails = useSelector((state) => state.Section.sectionDetails);
  const isEditTemplate = useSelector((state) => state.Section.isEditTemplate);

  const filterTemplatesDetails = panes?.[index]?.filter_template_details;
  const filterTemplates = filterTemplatesDetails?.filter_templates;
  const pinnedFiltersIds = filterTemplatesDetails?.pinned_filter_templates;
  const isCompType =
    panes?.[index]?.template_type === "competition" ? true : false;
  const templateObj = useSelector((state) => state.scheduleReport.templateObj);

  const selectedPill = panes[index]?.selected_pills
    ? panes[index]?.selected_pills
    : [];
  let dashboardDetails = panes?.[index];
  let showQuickFilter = true;
  // to show the selected pill filters
  useEffect(() => {
    if (selectedPill?.[0]?.saved_filters?.length) {
      dispatch(setSelectedPillInPane(selectedPill?.[0], index, panes));
    }
  }, []);

  const toshowPinnedTemplatePills = getPinnedTemplateDetails(
    filterTemplates,
    pinnedFiltersIds
  );
  const [selectedTemplatePill, setSelectedTemplatePill] = useState(
    selectedPill?.[0] || null
  );
  const [showFullDescription, setShowFullDescription] = useState(false);
  // const profileFilterList = useSelector(
  //   (state) => state?.apiCall?.profile_filter_list
  // );
  const profileFilterList =
    window.location.pathname?.split("/")?.[1] === "edit-dashboard" ||
    window.location.pathname?.split("/")?.[1] === "create-dashboard"
      ? templateDetails?.profile_filters_list
      : panes?.[index]?.profile_filters_list;
  const sectionLoader = useSelector((state) => state.ApiCall.sectionLoader);

  const [aiInsightModal, setAiInsightModal] = useState(false);
  const getWindowSize = () => {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  };

  const getPageSize = (windowSize) => {
    let currentWindowSize = windowSize?.innerWidth;

    if (currentWindowSize >= 2261) {
      return 21;
    } else if (currentWindowSize < 2261 && currentWindowSize >= 1905) {
      return 18;
    } else if (currentWindowSize < 1905 && currentWindowSize >= 1590) {
      return 15;
    } else if (currentWindowSize < 1590 && currentWindowSize >= 1278) {
      return 12;
    } else if (currentWindowSize < 1278 && currentWindowSize >= 966) {
      return 12;
    } else if (currentWindowSize < 966) {
      return 10;
    }
    return 12;
  };

  const [windowSize, setWindowSize] = useState(getWindowSize());
  const [pageSize, setPageSize] = useState(getPageSize(windowSize));
  const [selectQuickFilter, setSelectQuickFilter] = useState(false);
  const [restoredDashboardModal, setRestoredDashboardModal] = useState(false);

  const globalFinalFilter = getGlobalFilterAndFilterCountObject(
    "view_dashboard",
    deepCopy(panes[index]),
    graphConditionConfig
  );

  if (
    dashboardDetails?.template_type == "ticket" ||
    dashboardDetails?.categorisation === "Tickets"
  ) {
    showQuickFilter = false;
  } else if (
    dashboardDetails?.template_id in
    graphConditionConfig?.["realtime_template-global_filters"]
  ) {
    let templates = graphConditionConfig?.["realtime_template-global_filters"];
    if (!templates[dashboardDetails?.template_id]?.length) {
      showQuickFilter = false;
    }
  }

  let notMatchedFilters = useMemo(
    () =>
      removePrivateConversationFilters(
        panes?.[index]?.comp_hidden_filter,
        panes?.[index]?.filters,
        panes?.[index]?.saved_filters
      ),
    [panes]
  );

  let recentAppliedFilters = useMemo(
    () =>
      removeSavedFilters(
        panes?.[index]?.filters,
        panes?.[index]?.saved_filters,
        panes?.[index]?.comp_hidden_filter,
        panes?.[index]?.private_conversation
      ),
    [panes]
  );

  let filtersWithoutQuickFilters;
  if (selectedPill?.[0]?.saved_filters?.length) {
    recentAppliedFilters = removeHiddenFromSaved(
      deepCopy(recentAppliedFilters),
      deepCopy(selectedPill?.[0]?.saved_filters)
    );
    notMatchedFilters = removeHiddenFromSaved(
      deepCopy(notMatchedFilters),
      deepCopy(selectedPill?.[0]?.saved_filters)
    );
    filtersWithoutQuickFilters = removeHiddenFromSaved(
      deepCopy(panes?.[index]?.filters),
      deepCopy(selectedPill?.[0]?.saved_filters)
    );
  }

  // let predefinedCount = panes[index]?.quick_filter
  //   ? panes[index]?.filters
  //       ?.filter((d) => d?.columns[0]?.name !== null)
  //       ?.filter(
  //         (el) =>
  //           !graphConditionConfig?.[`quick-filter-keys`]?.includes(
  //             el?.attribute
  //           )
  //       )
  //   : panes[index]?.filters
  //       ?.filter((d) => d?.columns[0]?.name !== null)
  //       ?.filter((el) => el?.attribute !== "SettingID");
  let comp_brands = panes?.[index]?.brands?.[0]
    ? panes?.[index]?.brands?.[0]
    : panes?.[index]?.brands?.columns?.[0];

  useEffect(() => {
    if (config) {
      //to set filter panel data
      let myArray = getFilterPanelData(config);
      dispatch(setFilterPanelData(myArray));
    }
  }, [config]);

  const handleChange = (value, e) => {
    if (e === "yes") {
      handleDeleteTemplate();
      setModalShow(value);
    } else if (e === "no") {
      setModalShow(value);
    }
  };
  const deleteTemse = () => {
    setmodalText("Are you sure to delete this dashboard?");
    setModalShow(true);
  };
  const handleChangeShare = (value) => {
    setisModalShare(value);
  };

  const addFilterPanel = () => {
    dispatch(setisFilterPanelVisible(true));
    dispatch(setEditPanel(null));
    setSelectQuickFilter(false);
  };
  const removeFilterPanel = () => {
    dispatch(setisFilterPanelVisible(false));
    setfilterSearch("");
    setSelectQuickFilter(false);
  };

  const handleDeleteTemplate = () => {
    if (panes?.[index]?.allow_restore) {
      restroreDashboardFunction(true);
    } else {
      let index = getPaneIndex(panes, activeKey);
      let template_id = panes?.[index]?.template_id;
      dispatch(setClearTemplateData(null, index, panes));

      let paneObj = {
        panes: panes,
        activeKey: activeKey,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        type: window.location.pathname === "/schedule" ? "report" : "dashboard",
        graphConditionConfig: graphConditionConfig,
        index: index,
      };

      let basicObj = getTemplateListBasicObject(
        authParams,
        panes,
        index,
        pageSize,
        graphConditionConfig
      );

      authParams && dispatch(setDeleteTemplate(basicObj, template_id, paneObj));
      // dispatch(setIsDashboard(false, index, panes));
      // dispatch(setTemplateName(null, index, panes));

      // To Update Panes dashboard_template_filters state
      let dashboardObj = getTemplateListDashboardObject(
        authParams,
        pageSize,
        graphConditionConfig
      );
      dispatch(setDashboardTemplateFilters(dashboardObj, index, panes));

      // Delete Template from opened dashboard or inside dashboard
      if (window.location.pathname === "/dashboard") {
        history.push("/dashboard");
      } else if (window.location.pathname === "/pin-dashboard") {
        history.push("/pin-dashboard");
      }
    }
  };

  const passToEditTemplate = () => {
    let index = getPaneIndex(panes, activeKey);
    const templateValue = global?.panes ? global?.panes?.[index] : panes[index];
    let offset = null;

    dispatch(setSectionOffset({ offset: offset }));
    dispatch(setUpdateImpression(false));
    let sectionValue = templateValue?.sections
      ? templateValue?.sections
      : templateValue?.section;

    let section = sectionValue?.map((el) => {
      let brandsFilter = getBrands(
        brandlogicalgroup,
        el?.brand_ids,
        brands,
        el?.brand_groups
      );
      let onlyFilters = el?.filters?.filter(
        (e) => e?.attribute !== "CreatedDate" && e?.attribute !== "BrandID"
      );
      return {
        id: el?.section_id,
        name: el?.section_name,
        description: el?.section_description,
        isSectionAdded: templateValue?.sections ? true : false,
        isWidgetAdded: templateValue?.sections !== 0 ? true : false,
        duration: el?.duration,
        dateFilters: el?.dateFilters,
        brandFilters: brandsFilter,
        onlyFilters: onlyFilters,
        brands: brandsFilter ? [brandsFilter] : null,
        is_locked: el?.is_locked,
        relative_duration: el?.relative_duration || null,
        comp_brand_type:
          el?.comp_brand_type === false || el?.comp_brand_type === true
            ? el?.comp_brand_type
            : undefined,
        filters: el?.filters,
        onlyWidgets: el?.onlyWidgets,
        data: el?.widgets?.map((e) => {
          let brandsFilter_widget = getBrands(
            brandlogicalgroup,
            e?.brand_ids,
            brands,
            e?.brand_groups
          );
          let onlyFiltersInWidgets = e?.filters?.filter(
            (ee) =>
              ee?.attribute !== "CreatedDate" && ee?.attribute !== "BrandID"
          );
          if (e?.primary) {
            return {
              ...e,
              data: e?.graphData,
              // filters: e?.filters,
              onlyFilters: onlyFiltersInWidgets ? onlyFiltersInWidgets : null,
              // graph_type: e?.graph_type,
              // id: e?.widget_id,
              // is_custom: e?.is_custom ? true : false,
              description: e?.graphData?.description,
              // primary: e?.primary,
              // secondary: e?.secondary,
              // splits: e?.splits,
              // widget_name: e?.widget_name,
              // type: e?.type,
              // widget_id: e?.widget_id,
              // span: e?.span,
              // base: e?.base,
              // start_date: e?.start_date,
              // end_date: e?.end_date,
              duration: e?.startDate
                ? { from: e?.start_date, to: e?.end_date }
                : null,
              relative_duration: e?.relative_duration || null,
              // stacked: e?.stacked,
              // is_locked: e?.is_locked,
              original_widget_id:
                e?.type === "predefined" && e?.original_widget_id,
              is_imported: e?.type === "predefined" ? true : false,
              // source_template: e?.source_template,
              // percent: e?.percent,
              brandFilters: brandsFilter_widget,
              brands: brandsFilter_widget ? [brandsFilter_widget] : null,
              // log: e?.log,
              // supported_filters: e?.supported_filters,
              // payload: e?.payload,
              // profile_filters: e?.profile_filters,
              // profile_filters_flag: e?.profile_filters_flag,
              // profile_filters_list: e?.profile_filters_list,
              // brand_ids: e?.brand_ids,
              // brand_groups: e?.brand_groups,
            };
          } else if (e?.x_axis || e?.y_series || e?.chart) {
            return {
              ...e,
              data: e?.graphData,
              // filters: e?.filters ? e?.filters : null,
              onlyFilters: onlyFiltersInWidgets ? onlyFiltersInWidgets : null,
              // id: e?.widget_id,
              // widget_id: e?.widget_id,
              // widget_name: e?.widget_name ? e?.widget_name : null,
              // widget_description: e?.widget_description
              //   ? e?.widget_description
              //   : null,
              // x_axis: e?.x_axis,
              // y_axes: e?.y_axes,
              // y_series: e?.y_series,
              brandFilters: brandsFilter_widget,
              brands: brandsFilter_widget ? [brandsFilter_widget] : null,
              // chart: e?.chart,
              // order_by: e?.order_by,
              // start_date: e?.start_date,
              // end_date: e?.end_date,
              duration: e?.start_date
                ? { from: e?.start_date, to: e?.end_date }
                : null,
              relative_duration: e?.relative_duration || null,
              // is_locked: e?.is_locked ? e?.is_locked : false,
              span: e?.span ? e?.span : "full",
              // original_widget_id: e?.original_widget_id,
              is_imported: true,
              // log: e?.log,
              // data_source: e?.data_source,
              // com_brand_ids: e?.com_brand_ids,
              // duplicate_for_brands: e?.duplicate_for_brands,
              // originalWidgetName: e?.originalWidgetName,
              // parentId: e?.parentId,
              // childId: e?.childId,
              // type: e?.type,
              // engine: e?.engine,
              // supported_filters: e?.supported_filters,
              // payload: e?.payload,
              // profile_filters: e?.profile_filters,
              // profile_filters_flag: e?.profile_filters_flag,
              // profile_filters_list: e?.profile_filters_list,
              // brand_ids: e?.brand_ids,
              // brand_groups: e?.brand_groups,
            };
          }
        }),
        profile_filters_list: el?.profile_filters_list,
      };
    });

    dispatch(
      setSectionDetails({
        sectionKey: "edit_template",
        isSectionAdded: true,
        template_id: panes[getPaneIndex(panes, activeKey)].template_id,
      })
    );
    let pane_filters = templateValue?.filters;
    if (
      selectedPill !== undefined &&
      selectedPill?.length &&
      Object.keys(selectedPill?.[0]).length
    ) {
      pane_filters = removeHiddenFromSaved(
        pane_filters,
        selectedPill?.[0]?.saved_filters
      );
    }

    let quickFilterAttribute =
      templateValue.quick_filter === "AccountID"
        ? "SettingID"
        : templateValue?.quick_filter === "Category"
        ? "CategoryID"
        : templateValue.quick_filter;
    let quick_filter_value =
      quickFilterAttribute === templateValue?.quick_filter_value?.attribute
        ? templateValue?.quick_filter_value
        : null;
    let adsset_value = null,
      ads_value = null;
    if (quickFilterAttribute === "Ads_Campaign") {
      adsset_value = templateValue?.adsset_value?.attribute
        ? templateValue?.adsset_value
        : null;
      ads_value = templateValue?.ads_value?.attribute
        ? templateValue?.ads_value
        : null;
    }
    // if (templateValue?.quick_filter) {
    //   templateValue?.filters?.map((d) => {
    //     if (
    //       templateValue?.quick_filter === "CampaignID" &&
    //       d?.attribute === "CampaignID"
    //     ) {
    //       quick_filter_list = d;
    //     } else if (
    //       templateValue?.quick_filter === "AccountID" &&
    //       d?.attribute === "SettingID"
    //     ) {
    //       quick_filter_list = d;
    //     } else if (
    //       templateValue?.quick_filter === "Category" &&
    //       d?.attribute === "CategoryID"
    //     ) {
    //       quick_filter_list = d;
    //     } else if (
    //       templateValue?.quick_filter === "LocationID" &&
    //       d?.attribute === "LocationID"
    //     ) {
    //       quick_filter_list = d;
    //     }
    //   });
    // }

    // let quick_filter = quickFilterAttribute
    //   ? [
    //       {
    //         attribute: quickFilterAttribute,
    //         type: "varchar",
    //         columns: [
    //           {
    //             name:
    //               templateValue?.quick_filter === "Category"
    //                 ? (templateValue?.profiles?.[0]?.id).toString()
    //                 : (templateValue?.profiles?.[0]?.id).toString(),
    //             type: "include",
    //           },
    //         ],
    //       },
    //     ]
    //   : [];

    // let saved_similar_quick_filter_obj = getSimilarStaticFilter(
    //   [],
    //   templateValue?.filters,
    //   quick_filter
    // );
    // let saved_similar_hidden_filter_obj = getSimilarStaticFilter(
    //   templateValue?.hidden_filter ? [templateValue?.hidden_filter] : [],
    //   templateValue?.filters,
    //   []
    // );

    // let final_filters = removeHiddenAndQuickFilters(
    //   templateValue?.quick_filter,
    //   templateValue?.hidden_filter,
    //   templateValue?.filters
    // );
    // let saved_similar_quick_filter = saved_similar_quick_filter_obj?.filter;
    // if (saved_similar_quick_filter?.length) {
    //   final_filters = [...final_filters, ...saved_similar_quick_filter];
    // }
    // let saved_similar_hidden_filter = saved_similar_hidden_filter_obj?.filter;
    // if (saved_similar_hidden_filter?.length) {
    //   final_filters = [...final_filters, ...saved_similar_hidden_filter];
    // }

    dispatch(
      setTemplateDetails(templateDetails, {
        templateName: templateValue?.template_name,
        templateDescription: templateValue?.template_description,
        duration: templateValue?.duration,
        brands: templateValue?.brands,
        template_type: templateValue?.template_type,
        competition_aggregation:
          supportedBenchmarkTraceDashboardTypes?.includes(
            templateValue?.template_type
          )
            ? templateValue?.competition_aggregation || "avg"
            : null,
        advance_brands: templateValue?.template_global_brands,
        advance_duration: templateValue?.template_global_duration,
        quick_filter: templateValue?.quick_filter,
        filters: pane_filters,
        private_conversation: templateValue?.private_conversation,
        public_engagement_only: templateValue?.public_engagement_only,
        comp_hidden_filter: templateValue?.comp_hidden_filter,
        hidden_filter: templateValue?.hidden_filter,
        quick_filter_value: quick_filter_value,
        adsset_value: adsset_value,
        ads_value: ads_value,
        is_brand_locked: templateValue?.is_brand_locked,
        is_date_locked: templateValue?.is_date_locked,
        profile_filters_list: templateValue?.profile_filters_list,
      })
    );
    dispatch(setOptionHighChart(null));
    dispatch(setAddSection(Section, section, "update"));

    dispatch(setFooterValue({ section: false, widget: false, template: true }));

    dispatch(setIsEditTemplate(true));
    // PIN DEV Pass from opened dashboard to edit dashboard path
    history.push(
      `edit-dashboard/${panes[getPaneIndex(panes, activeKey)].template_id}`
    );
  };

  const handleShare = () => {
    if (panes?.[index]?.is_dashboard_edited) {
      dispatch(setSaveEditedDashboardModalFlag(true));
    } else {
      dispatch(
        setSharableData({
          template_id: panes[getPaneIndex(panes, activeKey)].template_id,
        })
      );

      let index = getPaneIndex(panes, activeKey);
      let template_id = panes[index].template_id;
      // dispatch default user list
      authParams &&
        dispatch(getDefaultShareableUserData(authParams, template_id));
      setisModalShare(true);
    }
  };

  const showPdfRules = () => {
    if (panes?.[index]?.is_dashboard_edited) {
      dispatch(setSaveEditedDashboardModalFlag(true));
    } else {
      let pane_brands = panes[index]?.brands?.columns
        ? panes[index]?.brands?.columns
        : panes[index]?.brands;
      if (pane_brands?.length > 50) {
        callNotification(
          "Report download with more than 50 brands is not allowed",
          "alert"
        );
        let brand_obj = getFormattedBrandsForApi(true, pane_brands);
        let feedbackObj = {
          report_download: true,
          report_id: panes[index]?.template_id,
          brand_groups:
            brand_obj?.brandsGroupName?.length > 0
              ? brand_obj?.brandsGroupName
              : null,
          comp_brand_list:
            pane_brands && pane_brands?.[0]?.competitor
              ? pane_brands?.[0]?.competitorList
              : null,
          brand_list:
            brand_obj?.single_brands && brand_obj?.single_brands?.[0]?.brand_id
              ? brand_obj?.single_brands
              : null,
          start_date: panes[index]?.duration?.from,
          end_date: panes[index]?.duration?.to,
          ptoken: authParams?.ptoken,
          user_id: authParams?.userid,
          title: "PDF Report download",
          description:
            "Report download with more than 50 brands is not allowed",
          graph_config: {},
          page: "dashboard",
        };
        dispatch(getfeedbackResponse(feedbackObj));
      } else {
        let unSupportedChart = ["bubble"];
        let index = getPaneIndex(panes, activeKey);
        let sections = panes[index]?.sections
          ? panes[index]?.sections
          : panes[index]?.section;
        let totalWidgets = [];
        sections &&
          sections?.map((sec) => {
            if (sec?.widgets) {
              totalWidgets = [...totalWidgets, ...sec?.widgets];
            }
          });
        let unSupportedWidgets =
          totalWidgets &&
          totalWidgets?.filter((el) => {
            return unSupportedChart?.includes(el?.graph_type);
          });
        if (unSupportedWidgets && unSupportedWidgets?.length > 0) {
          setTotalPdfWidgets(totalWidgets);
          setUnsupportedPdfWidgets(unSupportedWidgets);
          dispatch(setPdfModalOpen(true));
        } else {
          if (workspace_privileges?.ai_insights_ppt_pdf) {
            setAiInsightModal(true);
          } else {
            handleSchedulePdf();
          }
        }
      }
    }
  };

  const handleSchedulePdf = (AiInsightsData) => {
    let index = getPaneIndex(panes, activeKey);
    let twoMonthsDuration = getCustomizedDate(6, "Days");
    let defaultDuration = {
      from:
        moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.startTime,
      to:
        moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.endTime,
    };
    const d = new Date();
    let utcOffset = d.getTimezoneOffset();

    // let global_brands = getGlobalBrands(
    //   panes[index]?.brands,
    //   global_dashboard_single_brands,
    //   global_dashboard_brands,
    //   panes[index]?.template_type
    // );
    let global_brands = panes?.[index]?.brands;

    let filterId;
    panes[index]?.profiles?.map((d) => {
      if (d?.name === profileId) {
        filterId = d?.id;
      }
    });

    let quickFilter = panes[index]?.quick_filter_value
      ? panes[index]?.quick_filter_value
      : null;
    // new logic for formatting subset_filter in inner of columns
    let updatedColumnsMap = null;
    if (quickFilter && quickFilter?.attribute === "Ads_Campaign") {
      // Example call to the function
      updatedColumnsMap = processQuickFilterForADCampaign(panes, index);
    }
    let quickFilterWithSubsetFilter = null;
    if (updatedColumnsMap && Array.from(updatedColumnsMap?.values())?.length) {
      quickFilterWithSubsetFilter = panes?.[index]?.quick_filter_value
        ? { ...panes?.[index]?.quick_filter_value }
        : null;
      if (
        quickFilterWithSubsetFilter?.columns &&
        Array.isArray(quickFilterWithSubsetFilter?.columns)
      )
        quickFilterWithSubsetFilter.columns = Array.from(
          updatedColumnsMap?.values()
        );
    }

    //  {
    //   attribute:
    //     panes[index]?.quick_filter === "AccountID"
    //       ? "SettingID"
    //       : panes[index]?.quick_filter === "Category"
    //       ? "CategoryID"
    //       : panes[index]?.quick_filter,
    //   type: "varchar",
    //   columns: [
    //     {
    //       name: filterId,
    //       type: "include",
    //     },
    //   ],
    // };

    let finalFilter = panes[index]?.filters;
    // finalFilter = panes[index]?.filters?.filter(
    //   (d) => d.attribute !== quickFilter?.attribute
    // );
    // finalFilter = finalFilter?.filter(
    //   (d) => d.attribute !== panes[index]?.hidden_filter?.attribute
    // );

    let updatedSelectedDate = {
      from: moment(selectedDate?.from).format("YYYY/MM/DD 00:00"),
      to: moment(selectedDate?.to).format("YYYY/MM/DD 23:59"),
    };

    // let updatedGlobal_dashboard_duration = {
    //   from: moment(global_dashboard_duration?.from).format("YYYY/MM/DD 00:00"),
    //   to: moment(global_dashboard_duration?.to).format("YYYY/MM/DD 23:59"),
    // };

    let defaultProfileFilters = getByDefaultProfileFilters(profileFilterList);

    let pdfObject = {
      auth_params: authParams,
      brands: global_brands
        ? global_brands
        : brandlogicalgroup?.length > 0
        ? brandlogicalgroup
        : brands,
      comp_agg: panes[index]?.competition_aggregation,
      template_id: panes[index]?.template_id,
      utcoffset: utcOffset,
      start_date: selectedDate
        ? updatedSelectedDate?.from
        : defaultDuration?.from,
      end_date: selectedDate ? updatedSelectedDate?.to : defaultDuration?.to,
      schedule_json: scheduleObj?.ScheduleDetails,
      isBrandModified: global_brands ? true : false,
      filters: finalFilter ? finalFilter : [],
      hidden_filter: panes[index]?.hidden_filter
        ? panes[index]?.hidden_filter
        : null,
      quick_filter: quickFilterWithSubsetFilter
        ? quickFilterWithSubsetFilter
        : panes[index]?.quick_filter
        ? quickFilter
        : null,
      ai_insights_enabled: workspace_privileges?.ai_insights_ppt_pdf
        ? AiInsightsData
        : false,
      profile_filters: defaultProfileFilters ? defaultProfileFilters : null,
    };

    setAiInsightModal(false);
    dispatch(setPdfGenerateStatus(true));
    dispatch(setSchedulePdf(pdfObject));
    dispatch(setPdfModalOpen(false));
  };

  const handleDownloadPpt = () => {
    if (panes?.[index]?.is_dashboard_edited) {
      dispatch(setSaveEditedDashboardModalFlag(true));
    } else {
      let pane_brands = panes[index]?.brands?.columns
        ? panes[index]?.brands?.columns
        : panes[index]?.brands;
      if (pane_brands?.length > 50) {
        callNotification(
          "Report download with more than 50 brands is not allowed",
          "alert"
        );
        let brand_obj = getFormattedBrandsForApi(true, pane_brands);
        let feedbackObj = {
          report_download: true,
          report_id: panes[index]?.template_id,
          brand_groups:
            brand_obj?.brandsGroupName?.length > 0
              ? brand_obj?.brandsGroupName
              : null,
          comp_brand_list:
            pane_brands && pane_brands?.[0]?.competitor
              ? pane_brands?.[0]?.competitorList
              : null,
          brand_list:
            brand_obj?.single_brands && brand_obj?.single_brands?.[0]?.brand_id
              ? brand_obj?.single_brands
              : null,
          start_date: panes[index]?.duration?.from,
          end_date: panes[index]?.duration?.to,
          ptoken: authParams?.ptoken,
          user_id: authParams?.userid,
          title: "PPT Report download",
          description:
            "Report download with more than 50 brands is not allowed",
          graph_config: {},
          page: "dashboard",
        };
        dispatch(getfeedbackResponse(feedbackObj));
      } else {
        dispatch({
          type: "SET_PPT_ON_GENERATING_MODE",
          payload: !isPPTModalOpen,
        });
        dispatch(setPptTemplateData(authParams, false));
        dispatch(setPPTModalOpen(!isPPTModalOpen));
      }
    }
  };

  const openScheduleReportPop = () => {
    if (panes?.[index]?.is_dashboard_edited) {
      dispatch(setSaveEditedDashboardModalFlag(true));
    } else {
      let pane_brands = panes[index]?.brands?.columns
        ? panes[index]?.brands?.columns
        : panes[index]?.brands;
      if (pane_brands?.length > 50) {
        callNotification(
          "Report download with more than 50 brands is not allowed",
          "alert"
        );
        let brand_obj = getFormattedBrandsForApi(true, pane_brands);
        let feedbackObj = {
          report_download: true,
          report_id: panes[index]?.template_id,
          brand_groups:
            brand_obj?.brandsGroupName?.length > 0
              ? brand_obj?.brandsGroupName
              : null,
          comp_brand_list:
            pane_brands && pane_brands?.[0]?.competitor
              ? pane_brands?.[0]?.competitorList
              : null,
          brand_list:
            brand_obj?.single_brands && brand_obj?.single_brands?.[0]?.brand_id
              ? brand_obj?.single_brands
              : null,
          start_date: panes[index]?.duration?.from,
          end_date: panes[index]?.duration?.to,
          ptoken: authParams?.ptoken,
          user_id: authParams?.userid,
          title: "Schedule Report download",
          description:
            "Report download with more than 50 brands is not allowed",
          graph_config: {},
          page: "dashboard",
        };
        dispatch(getfeedbackResponse(feedbackObj));
      } else {
        let template = templateData?.find(
          (el) => el?.template_id === panes?.[index]?.template_id
        );
        template = template
          ? template
          : { template_id: panes?.[index]?.template_id };
        //added flag to indicate dashboard is open then scheduled report
        template.already_opened_dashboard = true;
        // dispatch(setIsDashboard(false, index, panes));
        dispatch(setIsDashboardScheduleTemplate(template));
        // redux state
        dispatch(setIsDashboardScheduleModal(true));
        dispatch(setIsScheduleReportOpen(true));
      }
    }
  };

  const handlePredefinedSaveAs = () => {
    if (panes?.[index]?.is_dashboard_edited) {
      dispatch(setSaveEditedDashboardModalFlag(true));
    } else {
      setIsModalSaveAs(true);
      dispatch(setDuplicateDashboardFlag(true));
      // dispatch(setSaveDashboardModalFlag(true));
    }
  };

  const handleCustomSaveAs = () => {
    if (panes?.[index]?.is_dashboard_edited) {
      dispatch(setSaveEditedDashboardModalFlag(true));
    } else {
      dispatch(setSaveDashboardModalFlag(true));
    }
  };

  const enableEditedDashboardModal = () => {
    dispatch(setSaveEditedDashboardModalFlag(true));
  };

  const menunew =
    graphConditionConfig?.realtime_refresh === panes?.[index]?.template_id ? (
      <>
        <Menu className="text_regular" style={{ minWidth: "15rem" }}>
          <Menu>
            {(!panes[index]?.predefined && templateAccessType === 1) ||
            (!workspace_privileges?.share_dashboard_public_enabled &&
              panes[index]?.predefined) ||
            (workspace_privileges?.share_dashboard_enabled &&
              !workspace_privileges?.share_dashboard_public_enabled &&
              !workspace_privileges?.share_dashboard_internal_enabled &&
              !graphConditionConfig?.account_detail_templates?.includes(
                panes?.[index]?.template_id
              ))
              ? ""
              : workspace_privileges?.share_dashboard_enabled && (
                  <Menu.Item
                    className="text-Darkgray font-size14 p-2 m-0"
                    style={{ lineHeight: "normal", height: "auto" }}
                    onClick={handleShare}
                    disabled={
                      panes[index]?.quick_filter &&
                      panes[index]?.profiles?.length === 0
                        ? true
                        : panes?.[index]?.campaign_date?.from >
                          moment(new Date()).format("YYYY/MM/DD H:mm")
                        ? true
                        : false
                    }
                  >
                    <img
                      src={
                        authParams?.theme_type === "1"
                          ? ShareDashboardWhite
                          : Share_Dashboard
                      }
                      alt="Share Icon"
                      style={{ maxWidth: "2.2rem" }}
                      className="mr-2"
                    />
                    Share
                  </Menu.Item>
                )}
          </Menu>
        </Menu>
      </>
    ) : (
      <Menu className="text_regular">
        <Menu>
          {panes?.[index]?.allow_pdf ? (
            <Menu.Item
              className="text-Darkgray font-size14 p-2 m-0"
              style={{ lineHeight: "normal", height: "auto" }}
              onClick={() => showPdfRules()}
              disabled={
                panes?.[index]?.is_ai_dashboard && !panes?.[index]?.is_ai_access
                  ? true
                  : panes[index]?.quick_filter &&
                    panes[index]?.profiles?.length === 0
                  ? true
                  : panes?.[index]?.campaign_date?.from >
                    moment(new Date()).format("YYYY/MM/DD H:mm")
                  ? true
                  : false
              }
            >
              <img
                src={authParams?.theme_type === "1" ? downloadWhite : download}
                alt="Download Report"
                style={{ maxWidth: "2.2rem" }}
                className="mr-2"
              />
              Download PDF
            </Menu.Item>
          ) : (
            ""
          )}

          {!graphConditionConfig?.[`realtime_template-global_filters`]?.[
            panes?.[index]?.template_id
          ] && panes?.[index]?.allow_ppt ? (
            <Menu.Item
              className={`text-Darkgray font-size14 p-2 m-0`}
              style={{ lineHeight: "normal", height: "auto" }}
              onClick={() => handleDownloadPpt()}
              disabled={
                panes?.[index]?.is_ai_dashboard && !panes?.[index]?.is_ai_access
                  ? true
                  : panes[index]?.quick_filter &&
                    panes[index]?.profiles?.length === 0
                  ? true
                  : panes?.[index]?.campaign_date?.from >
                    moment(new Date()).format("YYYY/MM/DD H:mm")
                  ? true
                  : false
              }
            >
              <span>
                <img
                  src={
                    authParams?.theme_type === "1"
                      ? downloadPptWhite
                      : downloadPpt
                  }
                  alt="Download PPT"
                  style={{ maxWidth: "2.2rem" }}
                  className="mr-2"
                />
                Download PPT
                <img
                  style={{ marginLeft: "0.5rem", maxWidth: "3.5rem" }}
                  //size={35}
                  src={betaBtn}
                  alt="Download PPT"
                />
              </span>
            </Menu.Item>
          ) : (
            ""
          )}
          {(!graphConditionConfig?.account_detail_templates?.includes(
            panes?.[index]?.template_id
          ) &&
            !panes[index]?.predefined &&
            templateAccessType === 1) ||
          (!workspace_privileges?.share_dashboard_public_enabled &&
            panes[index]?.predefined) ||
          (workspace_privileges?.share_dashboard_enabled &&
            !workspace_privileges?.share_dashboard_public_enabled &&
            !workspace_privileges?.share_dashboard_internal_enabled) ? (
            ""
          ) : workspace_privileges?.share_dashboard_enabled ? (
            <Menu.Item
              className="text-Darkgray font-size14 p-2 m-0"
              style={{ lineHeight: "normal", height: "auto" }}
              onClick={handleShare}
              disabled={
                panes?.[index]?.is_ai_dashboard && !panes?.[index]?.is_ai_access
                  ? true
                  : panes[index]?.quick_filter &&
                    panes[index]?.profiles?.length === 0
                  ? true
                  : panes?.[index]?.campaign_date?.from >
                    moment(new Date()).format("YYYY/MM/DD H:mm")
                  ? true
                  : false
              }
            >
              <img
                src={
                  authParams?.theme_type === "1"
                    ? ShareDashboardWhite
                    : Share_Dashboard
                }
                alt="Share Icon"
                style={{ maxWidth: "2.2rem" }}
                className="mr-2"
              />
              Share
            </Menu.Item>
          ) : (
            ""
          )}

          {/* Save As Feature */}
          {!urlParams?.startDate &&
          panes?.[index]?.access_type !== 1 &&
          !panes?.[index]?.predefined ? (
            <>
              <Menu.Item
                className="text-Darkgray font-size14 p-2 m-0"
                style={{ lineHeight: "normal", height: "auto" }}
                onClick={handleCustomSaveAs}
                disabled={
                  recentAppliedFilters
                    ? recentAppliedFilters?.length === 0
                      ? true
                      : false
                    : panes[index]?.quick_filter &&
                      panes[index]?.profiles?.length === 0
                    ? true
                    : panes?.[index]?.campaign_date?.from >
                      moment(new Date()).format("YYYY/MM/DD H:mm")
                    ? true
                    : false
                }
              >
                <Tooltip
                  title={
                    panes?.[index]?.template_type === "competition" &&
                    recentAppliedFilters?.length
                      ? ""
                      : panes?.[index]?.template_type !== "competition" &&
                        recentAppliedFilters?.length
                      ? ""
                      : "Added filters will be saved as new version of dashboard."
                  }
                >
                  <img
                    src={
                      authParams?.theme_type === "1"
                        ? SaveAsWhiteIcon
                        : SaveAsBlackIcon
                    }
                    alt="Share Icon"
                    style={{ maxWidth: "2.2rem" }}
                    className="mr-2"
                  />
                  Save As
                </Tooltip>
              </Menu.Item>
            </>
          ) : (
            !urlParams?.startDate &&
            templateAccessType === 1 &&
            panes?.[index]?.predefined && (
              <Menu.Item
                className="text-Darkgray font-size14 p-2 m-0"
                style={{ lineHeight: "normal", height: "auto" }}
                onClick={handlePredefinedSaveAs}
                disabled={
                  panes?.[index]?.template_type === "competition"
                    ? recentAppliedFilters
                      ? recentAppliedFilters?.length === 0
                        ? true
                        : false
                      : notMatchedFilters?.length === 0
                      ? true
                      : false
                    : recentAppliedFilters
                    ? recentAppliedFilters?.length === 0
                      ? true
                      : false
                    : panes?.[index]?.filters?.length === 0
                    ? true
                    : panes[index]?.quick_filter &&
                      panes[index]?.profiles?.length === 0
                    ? true
                    : panes?.[index]?.campaign_date?.from >
                      moment(new Date()).format("YYYY/MM/DD H:mm")
                    ? true
                    : false
                }
              >
                <Tooltip
                  title={
                    panes?.[index]?.template_type === "competition" &&
                    notMatchedFilters?.length
                      ? ""
                      : panes?.[index]?.template_type !== "competition" &&
                        filtersWithoutQuickFilters?.length
                      ? ""
                      : "Added filters will be saved as new version of dashboard."
                  }
                >
                  <img
                    src={
                      authParams?.theme_type === "1"
                        ? SaveAsWhiteIcon
                        : SaveAsBlackIcon
                    }
                    alt="Share Icon"
                    style={{ maxWidth: "2.2rem" }}
                    className="mr-2"
                  />
                  Save As
                </Tooltip>
              </Menu.Item>
            )
          )}

          {templateAccessType === 1 ? (
            ""
          ) : (
            <Menu.Item
              className={`${
                sectionLoader?.value
                  ? "disable text-Darkgray font-size14 p-2 m-0"
                  : "text-Darkgray font-size14 p-2 m-0"
              }`}
              // className="text-Darkgray font-size14 p-2 m-0"
              style={{ lineHeight: "normal", height: "auto" }}
            >
              <div
                onClick={() => passToEditTemplate()}
                className="text-Darkgray"
              >
                <img
                  src={authParams?.theme_type === "1" ? editWhite : edit}
                  alt="Edit Dashboard"
                  style={{ maxWidth: "2.2rem" }}
                  className="mr-2"
                />
                Edit
              </div>
            </Menu.Item>
          )}
          {templateAccessType == 1 || templateAccessType == 2 ? (
            ""
          ) : (
            <Menu.Item
              className={`${
                sectionLoader?.value
                  ? "disable text-Darkgray font-size14 p-2 m-0"
                  : "text-Darkgray font-size14 p-2 m-0"
              }`}
              // className="text-Darkgray font-size14 p-2 m-0"
              onClick={() => deleteTemse()}
              style={{ lineHeight: "normal", height: "auto" }}
            >
              <img
                src={authParams?.theme_type === "1" ? DeleteWhite : Delete}
                alt="Delete"
                style={{ maxWidth: "1.6rem" }}
                className="mr-2"
              />{" "}
              Delete
            </Menu.Item>
          )}

          {graphConditionConfig?.[`realtime_template-global_filters`]?.[
            panes?.[index]?.template_id
          ] || !panes?.[index]?.allow_scheduling ? (
            ""
          ) : (
            <Menu.Item
              className={`text-Darkgray font-size14 p-2 m-0`}
              onClick={openScheduleReportPop}
              style={{
                lineHeight: "normal",
                height: "auto",
              }}
              disabled={
                panes?.[index]?.is_ai_dashboard && !panes?.[index]?.is_ai_access
                  ? true
                  : panes[index]?.quick_filter &&
                    panes[index]?.profiles?.length === 0
                  ? true
                  : panes?.[index]?.campaign_date?.from >
                    moment(new Date()).format("YYYY/MM/DD H:mm")
                  ? true
                  : false
              }
            >
              <img
                src={
                  authParams?.theme_type === "1"
                    ? SchedulReportIconWhite
                    : SchedulReportIcon
                }
                alt="Schedule Report"
                style={{ maxWidth: "1.6rem" }}
                className="mr-2"
              />{" "}
              Schedule Report
            </Menu.Item>
          )}

          {panes?.[index]?.allow_restore ? (
            <Menu.Item
              className={`text-Darkgray font-size14 p-2 m-0`}
              onClick={() => handleRestoreDashboard(false)}
              style={{
                lineHeight: "normal",
                height: "auto",
              }}
            >
              <img
                src={
                  authParams?.theme_type === "1"
                    ? restoreWidgetIcon
                    : restoreWidgetIcon
                }
                alt="Restore Dashboard Icon"
                style={{ maxWidth: "2rem" }}
                className="mr-2"
              />{" "}
              <span style={{ marginLeft: "-0.4rem" }}>Restore Dashboard</span>
            </Menu.Item>
          ) : (
            ""
          )}
        </Menu>
      </Menu>
    );

  const handleModfiedDate = (value) => {
    // Update panes in Global state to get value, On change of global duration and brand
    dispatch(setTicketIsModifiedDate(value, panes, index));

    let paneObject = {
      // duration: obj,
      panes: panes,
      activeKey: activeKey,
      brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
      authParams: authParams,
      singleBrands: brands,
      index: index,
      competitorBrands: competitorBrands,
      graphConditionConfig: graphConditionConfig,
      // temporary_words: temporary_words,
      is_modified_date: value,
    };
    dispatch(setGlobalFilter(null, index, panes, paneObject));
  };

  const handlePillDetails = (template) => {
    if (
      selectedTemplatePill?.filter_template_id === template?.filter_template_id
    ) {
      setSelectedTemplatePill(null);
      dispatch(setSelectedPillInPane({}, index, panes));
    } else {
      setSelectedTemplatePill(template);
      dispatch(setSelectedPillInPane(template, index, panes));
    }
    let paneObj = {
      panes: panes,
      activeKey: activeKey,
      brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
      singleBrands: brands,
      authParams: authParams,
      index: index,
      competitorBrands: competitorBrands,
      graphConditionConfig: graphConditionConfig,
      is_modified_date:
        panes?.[index]?.template_id === "000-000-002" ||
        panes?.[index]?.template_id === "000-000-004"
          ? panes?.[index]?.is_modified_date
            ? panes?.[index]?.is_modified_date
            : false
          : null,
    };
    dispatch(setClearGraphData(index, panes, paneObj));
  };

  const openQuickFilter = () => {
    dispatch(setisFilterPanelVisible(true));
    if (filterTemplates?.length > 0) {
      setSelectQuickFilter(true);
    } else {
      setSelectQuickFilter(false);
    }
  };

  const handleShowDescription = () => {
    setShowFullDescription(!showFullDescription);
  };

  const handleRestoreDashboard = (flag) => {
    setRestoredDashboardModal(true);
  };

  const restroreDashboardFunction = (flag) => {
    let index = getPaneIndex(panes, activeKey);
    let template_id = panes?.[index]?.template_id;

    let paneObj = {
      panes: panes,
      activeKey: activeKey,
      // brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
      type: window.location.pathname === "/schedule" ? "report" : "dashboard",
      allow_restore: panes?.[index]?.allow_restore,
      authParams: authParams,
      selectBrands: templateObj?.brands,
      brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : Allbrands,
      index: index,
      singleBrands: Allbrands,
      competitorBrands: competitorBrands,
      global_dashboard_duration: global_dashboard_duration,
      global_dashboard_brands:
        panes[index].template_type === "ticket"
          ? global_dashboard_single_brands
          : global_dashboard_brands,
      graphConditionConfig: graphConditionConfig,
      template_deleted: flag,
    };
    let basicObj = getTemplateListBasicObject(
      authParams,
      panes,
      index,
      pageSize,
      graphConditionConfig
    );

    authParams && dispatch(setDeleteTemplate(basicObj, template_id, paneObj));
  };

  return (
    <>
      <div
        className={`d-flex justify-content-between flex-wrap align-items-center ml-3 mr-3 pt-2 ${
          !sections ? "" : "mb-0"
        } ${!sections && "pb-2"}   ${
          (graphLoader || aggregateLoader || profileLoader) && "disable"
        }`}
      >
        <div
          className={`d-flex align-items-start ${
            panes?.[index]?.dashboard_called_api_list?.length > 0 ||
            sectionLoader?.value ||
            graphLoader ||
            aggregateLoader ||
            profileLoader
              ? "disable"
              : ""
          }`}
        >
          {/* For Account Category Dropdown  */}
          {graphConditionConfig?.account_detail_templates?.includes(
            panes?.[index]?.template_id
          ) ? (
            <div
              className={`floating-label-group header-brands ProfileSelection SingleBrands__dropdown ${
                !sections && "mb-1"
              } analytics_brand`}
            >
              <span>
                <AccountList type="global_dashboard" />
              </span>
              <label
                className="portlet-label floating-label mr-15"
                style={{
                  backgroundColor: "#fff",
                  top: "-0.8rem",
                  fontSize: "1.2rem",
                }}
              >
                Account
              </label>
            </div>
          ) : (
            <div
              className={`floating-label-group header-brands ProfileSelection SingleBrands__dropdown ${
                !sections && "mb-1"
              } analytics_brand`}
              // style={{ minWidth: "18rem" }}
            >
              {/* <Brand type="global_dashboard" /> */}
              {
                // panes[index]?.template_id === "000-000-004" ||
                // panes[index]?.template_id === "000-000-002" ||
                // panes[index]?.template_id === "000-000-003" ||
                panes[index]?.template_id === "000-000-001" ? (
                  <SingleBrands
                    dashboard={
                      panes[index]?.template_id === "000-000-001" &&
                      "ormDashboard"
                    }
                    type="global_dashboard"
                  />
                ) : (
                  <span
                    className={`${panes[index]?.is_brand_locked && "disable"}`}
                  >
                    <BrandsLogicalGroup type="global_dashboard" />
                  </span>
                )
              }
              <label
                className="portlet-label floating-label mr-15"
                style={{
                  backgroundColor: "#fff",
                  top: "-0.8rem",
                  fontSize: "1.2rem",
                }}
              >
                Brand
              </label>
            </div>
          )}
          {panes[index]?.template_id === "000-000-001" ||
          panes[index]?.template_id === "000-000-002" ||
          panes[index]?.template_id === "000-000-003" ||
          panes[index]?.template_id === "000-000-004" ? (
            ""
          ) : (
            <>
              {panes[index]?.quick_filter && (
                <div className="floating-label-group ProfileSelection header-brands ml-15 analytics_brand">
                  <ProfileSelection
                    AccountType={panes[index]?.quick_filter}
                    type="global_dashboard"
                  />
                  <label
                    className="portlet-label floating-label mr-15"
                    style={{
                      backgroundColor: "#fff",
                      top: "-0.8rem",
                      fontSize: "1.2rem",
                    }}
                  >
                    {panes[index]?.quick_filter === "AccountID"
                      ? "Profiles"
                      : panes[index]?.quick_filter === "ObjectID"
                      ? "Form"
                      : panes[index]?.quick_filter === "LocationID"
                      ? "Location"
                      : panes[index]?.quick_filter?.toLowerCase() ===
                        "fbgroupid"
                      ? "Facebook Group"
                      : panes[index]?.quick_filter === "Ticket_Tagging"
                      ? "Labels"
                      : panes[index]?.quick_filter === "Category"
                      ? "Category"
                      : panes[index]?.quick_filter === "Ads_Campaign"
                      ? "AD Campaign"
                      : panes[index]?.quick_filter === "ProfileID"
                      ? "Location Profiles"
                      : panes[index]?.quick_filter === "CampaignID" &&
                        "Campaigns"}
                  </label>
                </div>
              )}
              {panes[index]?.quick_filter === "Ads_Campaign" &&
              Array.isArray(panes[index]?.adsset_list) &&
              panes[index]?.adsset_list?.length ? (
                <div className="floating-label-group ProfileSelection header-brands ml-15 analytics_brand">
                  <ProfileSelection
                    AccountType={panes[index]?.quick_filter}
                    IsAdsSetType={true}
                    type="global_dashboard"
                  />
                  <label
                    className="portlet-label floating-label mr-15"
                    style={{
                      backgroundColor: "#fff",
                      top: "-8px",
                      fontSize: "12px",
                    }}
                  >
                    {"AD Sets"}
                  </label>
                </div>
              ) : (
                ""
              )}
              {panes[index]?.quick_filter === "Ads_Campaign" &&
              Array.isArray(panes[index]?.ads_list) &&
              panes[index]?.ads_list?.length ? (
                <div className="floating-label-group ProfileSelection header-brands ml-15 analytics_brand">
                  <ProfileSelection
                    AccountType={panes[index]?.quick_filter}
                    IsAdsType={true}
                    type="global_dashboard"
                  />
                  <label
                    className="portlet-label floating-label mr-15"
                    style={{
                      backgroundColor: "#fff",
                      top: "-8px",
                      fontSize: "12px",
                    }}
                  >
                    {"ADs"}
                  </label>
                </div>
              ) : (
                ""
              )}
            </>
          )}

          {(panes?.[index]?.brands?.[0] ||
            panes?.[index]?.brands?.columns?.[0]?.competitor) &&
            panes?.[index]?.template_type === "competition" && (
              <>
                <div className="comp__brand--wrapper mb-1">
                  {comp_brands ? (
                    <CompetitorBrandLabels
                      comp_brands={comp_brands}
                      comp_brands_length={comp_brands?.competitorList?.length}
                    />
                  ) : (
                    ""
                  )}
                </div>
                {/* <div className="comp_brand_container d-none">
                  <div className="comp_brand_box">
                    {comp_brands && (
                      <span style={{ margin: "1rem" }}>
                        <span
                          className="comp_brand_color"
                          style={
                            comp_brands?.brand_color
                              ? { backgroundColor: comp_brands?.brand_color }
                              : { border: "0.1rem solid var(--secondary-color)" }
                          }
                        ></span>
                        <span className="comp_list_brand_text">
                          <Tooltip title={comp_brands?.brand_friendly_name}>
                            {comp_brands?.brand_friendly_name?.length > 10
                              ? comp_brands?.brand_friendly_name?.substr(
                                  0,
                                  10
                                ) + " ..."
                              : comp_brands?.brand_friendly_name}

                          </Tooltip>
                        </span>
                      </span>
                    )}

                    {comp_brands?.competitorList &&
                      comp_brands?.competitorList?.map((d) => {
                        return (
                          <span style={{ margin: "1rem" }}>
                            <span
                              className="comp_brand_color"
                              style={
                                d?.comp_brand_color
                                  ? { backgroundColor: d?.comp_brand_color }
                                  : {
                                      border:
                                        "0.1rem solid var(--secondary-color)",
                                    }
                              }
                            ></span>
                            <span className="comp_list_brand_text">
                              <Tooltip title={d?.brand_friendly_name}>
                                {d?.brand_friendly_name?.length > 10
                                  ? d?.brand_friendly_name?.substr(0, 10) +
                                    " ..."
                                  : d?.brand_friendly_name}

                              </Tooltip>
                            </span>
                          </span>
                        );
                      })}
                  </div>
                </div> */}
              </>
            )}
        </div>

        <div className="d-flex justify-content-md-between justify-content-sm-around flex-wrap  align-items-center  ">
          {/* Show Modified and Created Date Dropdown */}
          {(panes?.[index]?.template_id === "000-000-002" ||
            panes?.[index]?.template_id === "000-000-004") && (
            <div style={{ marginRight: "1rem" }}>
              <Select
                style={{
                  width: "13rem",
                }}
                className="sharable-dropdown border-color"
                defaultValue={false}
                value={
                  panes?.[index]?.is_modified_date
                    ? panes?.[index]?.is_modified_date
                    : false
                }
                onChange={handleModfiedDate}
              >
                <Option value={false}>Created Date</Option>
                <Option value={true}>Modified Date</Option>
              </Select>
            </div>
          )}

          {/* When we edited any widget, it will enable automatically */}
          {/* To save the edited dashboard */}
          {panes[index]?.is_dashboard_edited ? (
            <Tooltip placement="topLeft" title="">
              <Button
                style={{ height: "4.2rem", borderRadius: "0.8rem" }}
                className="ant-btn-primary ant-btn-primary_blue ml-2 shadow-none border-color mr-2"
                onClick={() => enableEditedDashboardModal()}
              >
                {/* <Avatar
                  shape="square"
                  size="small"
                  src={
                    authParams?.theme_type === "1"
                      ? SaveAsWhiteIcon
                      : SaveAsBlackIcon
                  }
                  alt="Save Edited Dashboard Button"
                /> */}
                Save
              </Button>
            </Tooltip>
          ) : (
            ""
          )}
          {graphConditionConfig?.template_calender_action_controls?.includes(
            panes[index]?.template_id
          ) ? (
            <>
              <div
                className={`${
                  (panes?.[index]?.dashboard_called_api_list?.length > 0 ||
                    sectionLoader?.value ||
                    graphLoader ||
                    aggregateLoader ||
                    profileLoader) &&
                  "disable"
                }`}
              >
                <span
                  className={`${panes[index]?.is_date_locked && "disable"}`}
                  style={{
                    minWidth: "29rem",
                  }}
                >
                  {!graphConditionConfig?.[
                    `realtime_template-global_filters`
                  ]?.[panes?.[index]?.template_id] && (
                    <CustomDurationCalendar type="global_dashboard" />
                  )}
                </span>
              </div>
            </>
          ) : (
            <div
              className={`${
                (panes?.[index]?.dashboard_called_api_list?.length > 0 ||
                  sectionLoader?.value ||
                  graphLoader ||
                  aggregateLoader ||
                  profileLoader) &&
                "disable"
              }`}
            >
              <span
                className={`${panes[index]?.is_date_locked && "disable"}`}
                style={{
                  minWidth: "29rem",
                }}
              >
                {!graphConditionConfig?.[`realtime_template-global_filters`]?.[
                  panes?.[index]?.template_id
                ] && <Datetime type="global_dashboard" />}
              </span>
            </div>
          )}
          {!graphConditionConfig?.template_calender_action_controls?.includes(
            panes[index]?.template_id
          ) ? (
            <div
              className={`${
                (panes?.[index]?.dashboard_called_api_list?.length > 0 ||
                  sectionLoader?.value ||
                  graphLoader ||
                  aggregateLoader ||
                  profileLoader) &&
                "disable"
              }`}
            >
              {!["000-000-004", "000-000-001"]?.includes(
                panes[index]?.template_id
              ) &&
              (!graphConditionConfig?.[`realtime_template-global_filters`]?.[
                panes[index]?.template_id
              ] ||
                (graphConditionConfig?.[`realtime_template-global_filters`]?.[
                  panes[index]?.template_id
                ] &&
                  graphConditionConfig?.[`realtime_template-global_filters`]?.[
                    panes[index]?.template_id
                  ]?.length)) &&
              (graphConditionConfig?.[`template-global_filters`]?.[
                panes[index]?.template_id
              ]
                ? graphConditionConfig?.[`template-global_filters`]?.[
                    panes[index]?.template_id
                  ].length > 0
                : true) ? (
                <Tooltip
                  overlayStyle={{
                    width:
                      panes[index] &&
                      panes[index]?.filters?.length > 0 &&
                      panes[index]?.filters?.findIndex((el) => {
                        return !graphConditionConfig?.[
                          `quick-filter-keys`
                        ]?.includes(el?.attribute);
                      }) !== -1 &&
                      "20rem",
                  }}
                  color="#3B5175"
                  title={
                    globalFinalFilter?.filters?.length > 0 ? (
                      <div
                        className="custom_scroll"
                        style={{
                          maxWidth: "27rem",
                          maxHeight: "23rem",
                          overflow: "auto",
                          scrollBehavior: "smooth",
                        }}
                      >
                        <div className="mb-1">
                          {globalFinalFilter?.filters?.map((el) => {
                            let data =
                              panes[index]?.filterPanelData?.result?.schema[
                                el?.attribute
                              ]?.values;

                            return !(
                              panes[index]?.template_id === "000-000-002" ||
                              panes[index]?.template_id === "000-000-003"
                            ) ? (
                              globalFinalFilter?.filters?.length ? (
                                <div className="mb-2">
                                  <p
                                    className="mb-0"
                                    style={{
                                      color:
                                        el?.type === "include"
                                          ? "#5ed66d"
                                          : el?.type === "exclude" && "#fb7665",
                                    }}
                                  >
                                    <strong>
                                      {All_Share_attributes
                                        ? el?.attribute?.toLowerCase() ===
                                          "opinion_cid"
                                          ? "Opinions"
                                          : All_Share_attributes?.[
                                              el?.attribute
                                            ]
                                          ? All_Share_attributes?.[
                                              el?.attribute
                                            ]
                                          : All_Share_attributes?.[
                                              el?.attribute?.endsWith("ID")
                                                ? el?.attribute?.replace(
                                                    "ID",
                                                    ""
                                                  )
                                                : el?.attribute
                                            ]
                                          ? All_Share_attributes?.[
                                              el?.attribute?.endsWith("ID")
                                                ? el?.attribute?.replace(
                                                    "ID",
                                                    ""
                                                  )
                                                : el?.attribute
                                            ]
                                          : el?.attribute?.toLowerCase() ===
                                            "categoryid"
                                          ? "Category"
                                          : el?.attribute?.toLowerCase() ===
                                            "subcategoryid_aug"
                                          ? "Sub Category"
                                          : el?.attribute?.toLowerCase() ===
                                            "subsubcategoryid"
                                          ? "Sub Sub Category"
                                          : el?.attribute?.endsWith("ID")
                                          ? el?.attribute?.replace("ID", "")
                                          : el?.attribute?.replace("Type", "")
                                        : el?.attribute?.endsWith("ID")
                                        ? el?.attribute?.replace("ID", "")
                                        : el?.attribute?.replace("Type", "")}
                                    </strong>
                                  </p>
                                  {el?.type === "int" &&
                                    !Array.isArray(el?.columns) && (
                                      <span className="font-weight-light text-white">
                                        {el?.columns?.from +
                                          " - " +
                                          el?.columns?.to}
                                      </span>
                                    )}
                                  {Array.isArray(el?.columns) &&
                                    el?.columns?.map((e, index) => {
                                      return (
                                        <span
                                          className="font-weight-light"
                                          style={{
                                            color:
                                              e?.type === "include"
                                                ? "#5ed66d"
                                                : e?.type === "exclude"
                                                ? "#fb7665"
                                                : "#fff",
                                          }}
                                        >
                                          {/* {(index ? ", " : "") +
                                            (e?.display_name
                                              ? e?.display_name
                                              : e?.name)} */}

                                          {[
                                            "FeedBackEnabled",
                                            "ShowDeletedFromSocial",
                                            "AutoClosureEnabled",
                                            "IsWorkingHour",
                                          ]?.includes(el?.attribute)
                                            ? e?.name === null
                                              ? "Any"
                                              : e?.name === 0
                                              ? "No"
                                              : e?.name === 1 && "Yes"
                                            : (index ? ", " : "") +
                                              (e?.display_name
                                                ? e?.display_name
                                                : e?.name)}
                                        </span>
                                      );
                                    })}
                                </div>
                              ) : (
                                "Filter"
                              )
                            ) : (
                              <div className="mb-2">
                                <p className="mb-0 text-white">
                                  <strong>
                                    {panes[index]?.template_id ===
                                      "000-000-003" &&
                                    el?.attribute === "IsWorkingHour"
                                      ? "Is Working Hour"
                                      : All_Share_attributes &&
                                        el?.attribute?.toLowerCase() ===
                                          "opinion_cid"
                                      ? "Opinions"
                                      : All_Share_attributes?.[el?.attribute]
                                      ? All_Share_attributes?.[el?.attribute]
                                      : All_Share_attributes[
                                          el?.attribute?.endsWith("ID")
                                            ? el?.attribute?.replace("ID", "")
                                            : el?.attribute
                                        ]
                                      ? All_Share_attributes[
                                          el?.attribute?.endsWith("ID")
                                            ? el?.attribute?.replace("ID", "")
                                            : el?.attribute
                                        ]
                                      : panes[index]?.filterPanelData?.result
                                          ?.schema
                                      ? panes[index]?.filterPanelData?.result
                                          ?.schema?.[el?.attribute]?.title
                                      : el?.attribute?.toLowerCase() ===
                                        "categoryid"
                                      ? "Category"
                                      : el?.attribute?.toLowerCase() ===
                                        "subcategoryid_aug"
                                      ? "Sub Category"
                                      : el?.attribute?.toLowerCase() ===
                                        "subsubcategoryid"
                                      ? "Sub Sub Category"
                                      : el?.attribute?.replace("Type", "")}
                                  </strong>
                                </p>
                                {Array.isArray(el?.columns) &&
                                  el?.columns?.map((e, index) => {
                                    let toolTipTextName =
                                      Array.isArray(data) &&
                                      data?.filter(
                                        (g) => e?.name === g?.id
                                      )?.[0]?.name;
                                    if (!toolTipTextName) {
                                      toolTipTextName = e?.display_name;
                                    }
                                    return (
                                      <span
                                        className="font-weight-light"
                                        style={{
                                          color:
                                            e?.type === "include"
                                              ? "#5ed66d"
                                              : e?.type === "exclude"
                                              ? "#fb7665"
                                              : "#fff",
                                        }}
                                      >
                                        {[
                                          "FeedBackEnabled",
                                          "ShowDeletedFromSocial",
                                          "AutoClosureEnabled",
                                          "IsWorkingHour",
                                        ]?.includes(el?.attribute)
                                          ? e?.name === null
                                            ? "Any"
                                            : e?.name === 0
                                            ? "No"
                                            : e?.name === 1 && "Yes"
                                          : (index ? ", " : "") +
                                            toolTipTextName}
                                      </span>
                                    );
                                  })}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    ) : (
                      "Filter"
                    )
                  }
                  placement="leftTop"
                >
                  <Badge
                    style={{ backgroundColor: "#185edf", fontSize: "1rem" }}
                    size="small"
                    count={
                      globalFinalFilter?.filters
                        ? globalFinalFilter?.filters?.length
                        : 0
                    }
                  >
                    <Button
                      className="header-btn ml-2 p-0 shadow-none border-color"
                      onClick={() => addFilterPanel()}
                    >
                      <Avatar
                        shape="square"
                        size="small"
                        src={
                          authParams?.theme_type === "1"
                            ? filterSmallWhite
                            : filterSmall
                        }
                        alt="Header Filter"
                      />
                    </Button>
                  </Badge>
                </Tooltip>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}

          {panes?.[index]?.predefined &&
          panes?.[index]?.template_type === "ticket" ? (
            ""
          ) : (
            <Button className="header-btn ml-2 p-0 shadow-none border-color">
              <Dropdown
                overlayClassName={
                  authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
                }
                overlay={menunew}
              >
                <span
                  style={{ padding: "0.5rem 1.5rem" }}
                  onClick={(e) => e.preventDefault()}
                >
                  <img
                    src={authParams?.theme_type === "1" ? dotsWhite : dots}
                    alt="more"
                  />
                </span>
              </Dropdown>
            </Button>
          )}
        </div>
      </div>
      {/*pinned quick-filters */}
      {showQuickFilter &&
      (window.location.pathname?.split("/")[1]?.toLowerCase() === "dashboard" ||
        window.location.pathname?.split("/")[1]?.toLowerCase() ===
          "pin-dashboard") &&
      shareTemplateData == null &&
      (graphConditionConfig?.[`template-global_filters`]?.[
        panes[index]?.template_id
      ]
        ? graphConditionConfig?.[`template-global_filters`]?.[
            panes[index]?.template_id
          ].length > 0
        : true) ? (
        <div
          style={{
            gap: "1.6rem",
          }}
          className={`${"QuickFilterList d-flex flex-wrap align-items-center ml-3 mr-3 mb-0"}${
            panes?.[index]?.sections?.length ? " quick-pt-10" : " quick-pb-8"
          }`}
        >
          <div
            style={{ padding: "0.4rem 0rem" }}
            className="d-flex justify-content-center align-items-center gap-4"
          >
            <img src={Blue_Pin} alt="pin-icon" />
            <span className="section__btn line-height-normal tab_items box-shadow-none mr-0 pr-0 p-0 ">
              Quick Filter{toshowPinnedTemplatePills?.length > 1 ? "s" : ""}:
            </span>
            <div className="d-flex justify-content-center align-items-center gap-4">
              <Tooltip title="Click here to configure quick filters">
                <PlusCircleOutlined
                  className="QuickFilterList__plusIcon"
                  // style={{ fontSize: "2rem", color: "#3b5175" }}
                  onClick={openQuickFilter}
                />
              </Tooltip>
            </div>
          </div>
          {toshowPinnedTemplatePills?.map((template, index) => (
            <div
              key={index}
              className={`QuickFilterList__item ${
                selectedTemplatePill?.filter_template_id ===
                template.filter_template_id
                  ? "selected"
                  : ""
              }`}
              style={
                {
                  // cursor: "pointer",
                  // borderRadius: "2rem",
                  // padding: "0.2rem 0.6rem",
                  // border: "0.1rem solid transparent",
                  // display: "flex",
                  // alignItems: "center",
                  // backgroundColor: `${
                  //   selectedTemplatePill?.filter_template_id ===
                  //   template.filter_template_id
                  //     ? "#185edf1a"
                  //     : "#e6e5e5"
                  // }`,
                  // borderColor: `${
                  //   selectedTemplatePill?.filter_template_id ===
                  //   template.filter_template_id
                  //     ? "rgb(24, 94, 223)"
                  //     : "transparent"
                  // }`,
                }
              }
            >
              <Tooltip
                overlayStyle={{
                  width: "30rem",
                }}
                overlayInnerStyle={{
                  padding: "0.8rem",
                  borderRadius: "0.8rem",
                }}
                overlayClassName="QuickFilterList__Tooltip"
                color="#fff"
                onOpenChange={() => setShowFullDescription(false)}
                title={
                  <>
                    <div className="mb-1">
                      <div className="mb-2">
                        <>
                          {" "}
                          <p className="mb-0 pb-0">
                            <span
                              style={{
                                color: "#3b5175",
                                fontSize: "1.5rem",
                              }}
                              className="text-transform__capitalize"
                            >
                              <strong>{template?.filter_template_name}</strong>
                            </span>
                          </p>
                        </>
                        {template?.filter_template_description?.trim() ? (
                          <>
                            <span
                              style={{
                                color: "#3b5175",
                              }}
                              className="d-flex justify-content-between align-items-center"
                            >
                              {template?.filter_template_description?.length >
                              25 ? (
                                <>
                                  {!showFullDescription ? (
                                    <>
                                      <span style={{ maxWidth: "16.3rem" }}>
                                        {template?.filter_template_description?.slice(
                                          0,
                                          20
                                        )}
                                      </span>
                                      <span
                                        style={{
                                          color: "#185edf",
                                          cursor: "pointer",
                                        }}
                                        onClick={() => handleShowDescription()}
                                      >
                                        See more...
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <div style={{ wordBreak: "break-word" }}>
                                        <span>
                                          {
                                            template?.filter_template_description
                                          }
                                          <span
                                            style={{
                                              color: "#185edf",
                                              cursor: "pointer",
                                              display: "flex",
                                            }}
                                            onClick={() =>
                                              handleShowDescription()
                                            }
                                          >
                                            See less
                                          </span>
                                        </span>
                                      </div>
                                    </>
                                  )}
                                </>
                              ) : (
                                template?.filter_template_description
                              )}
                            </span>
                          </>
                        ) : (
                          ""
                        )}
                        <hr
                          style={{
                            backgroundColor: "#185edf1a",
                            margin: "0.8rem 0",
                          }}
                        />
                      </div>
                    </div>

                    {/* saved filter here refers filter inside quick filter pill */}
                    {template?.saved_filters?.length > 0 ? (
                      <div
                        className="custom_scroll_quickfilter_header_tooltip"
                        style={{
                          maxWidth: "27rem",
                          maxHeight: "23rem",
                          overflow: "auto",
                          scrollBehavior: "smooth",
                        }}
                      >
                        <div className="mb-1">
                          {template?.saved_filters?.map((el, mappedIndex) => {
                            let data =
                              panes[index]?.filterPanelData?.[el?.attribute]
                                ?.values;

                            return !(
                              panes[index]?.template_id === "000-000-002" ||
                              panes[index]?.template_id === "000-000-003"
                            ) ? (
                              template?.saved_filters?.length ? (
                                <div className="mb-2" key={mappedIndex}>
                                  <p
                                    className="mb-0"
                                    style={{
                                      color: "#3b5175",
                                    }}
                                  >
                                    <strong>
                                      {All_Share_attributes
                                        ? el?.attribute?.toLowerCase() ===
                                          "opinion_cid"
                                          ? "Opinions"
                                          : All_Share_attributes?.[
                                              el?.attribute
                                            ]
                                          ? All_Share_attributes?.[
                                              el?.attribute
                                            ]
                                          : All_Share_attributes?.[
                                              el?.attribute?.endsWith("ID")
                                                ? el?.attribute?.replace(
                                                    "ID",
                                                    ""
                                                  )
                                                : el?.attribute
                                            ]
                                          ? All_Share_attributes?.[
                                              el?.attribute?.endsWith("ID")
                                                ? el?.attribute?.replace(
                                                    "ID",
                                                    ""
                                                  )
                                                : el?.attribute
                                            ]
                                          : el?.attribute?.toLowerCase() ===
                                            "categoryid"
                                          ? "Category"
                                          : el?.attribute?.toLowerCase() ===
                                            "subcategoryid_aug"
                                          ? "Sub Category"
                                          : el?.attribute?.toLowerCase() ===
                                            "subsubcategoryid"
                                          ? "Sub Sub Category"
                                          : el?.attribute?.endsWith("ID")
                                          ? el?.attribute?.replace("ID", "")
                                          : el?.attribute?.replace("Type", "")
                                        : el?.attribute?.endsWith("ID")
                                        ? el?.attribute?.replace("ID", "")
                                        : el?.attribute?.replace("Type", "")}
                                    </strong>
                                  </p>
                                  {el?.type === "int" &&
                                    !Array.isArray(el?.columns) && (
                                      <span
                                        // className="font-weight-light text-white"
                                        style={{ color: "#3b5175" }}
                                      >
                                        {el?.columns?.from +
                                          " - " +
                                          el?.columns?.to}
                                      </span>
                                    )}
                                  {Array.isArray(el?.columns) &&
                                    el?.columns?.map((e, index) => {
                                      return (
                                        <span
                                          className={
                                            e?.type === "exclude"
                                              ? " font-weight500"
                                              : " font-weight400"
                                          }
                                          style={{
                                            color:
                                              e?.type === "include"
                                                ? "#5ed66d"
                                                : e?.type === "exclude"
                                                ? "#fb7665"
                                                : "#3b5175",
                                          }}
                                        >
                                          {(index ? ", " : "") +
                                            (e?.display_name
                                              ? e?.display_name
                                              : e?.name)}
                                        </span>
                                      );
                                    })}
                                </div>
                              ) : (
                                ""
                              )
                            ) : (
                              <div className="mb-2">
                                <p className="mb-0 text-white">
                                  <strong>
                                    {panes[index]?.template_id ===
                                      "000-000-003" &&
                                    el?.attribute === "IsWorkingHour"
                                      ? "Is Working Hour"
                                      : All_Share_attributes &&
                                        el?.attribute?.toLowerCase() ===
                                          "opinion_cid"
                                      ? "Opinions"
                                      : All_Share_attributes?.[el?.attribute]
                                      ? All_Share_attributes?.[el?.attribute]
                                      : All_Share_attributes[
                                          el?.attribute?.endsWith("ID")
                                            ? el?.attribute?.replace("ID", "")
                                            : el?.attribute
                                        ]
                                      ? All_Share_attributes[
                                          el?.attribute?.endsWith("ID")
                                            ? el?.attribute?.replace("ID", "")
                                            : el?.attribute
                                        ]
                                      : panes[index]?.filterPanelData
                                      ? panes[index]?.filterPanelData?.[
                                          el?.attribute
                                        ]?.title
                                      : el?.attribute?.toLowerCase() ===
                                        "categoryid"
                                      ? "Category"
                                      : el?.attribute?.toLowerCase() ===
                                        "subcategoryid_aug"
                                      ? "Sub Category"
                                      : el?.attribute?.toLowerCase() ===
                                        "subsubcategoryid"
                                      ? "Sub Sub Category"
                                      : el?.attribute?.replace("Type", "")}
                                  </strong>
                                </p>
                                {Array.isArray(el?.columns) &&
                                  el?.columns?.map((e, index) => {
                                    return (
                                      <span
                                        className={
                                          e?.type === "exclude"
                                            ? " font-weight500"
                                            : " font-weight400"
                                        }
                                        style={{
                                          color:
                                            e?.type === "include"
                                              ? "#5ed66d"
                                              : e?.type === "exclude"
                                              ? "#fb7665"
                                              : "#3b5175",
                                        }}
                                      >
                                        {[
                                          "FeedBackEnabled",
                                          "ShowDeletedFromSocial",
                                          "AutoClosureEnabled",
                                          "IsWorkingHour",
                                        ]?.includes(el?.attribute)
                                          ? e?.name === null
                                            ? "Any"
                                            : e?.name === 0
                                            ? "No"
                                            : e?.name === 1 && "Yes"
                                          : (index ? ", " : "") +
                                            data?.filter(
                                              (g) => e?.name === g?.id
                                            )[0]?.name}
                                      </span>
                                    );
                                  })}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                }
                placement="bottom"
              >
                <span
                  className="QuickFilterList__item--pill"
                  onClick={() => handlePillDetails(template)}
                >
                  <img src={quickfiltericon} alt="ticked-icon" />
                  <span
                    // style={{ fontWeight: "400", marginRight: "0rem" }}
                    className="QuickFilterList__item--pillItem section__btn line-height-normal tab_items box-shadow-none p-10"
                  >
                    <strong>
                      {template?.filter_template_name?.length > 25
                        ? template?.filter_template_name.slice(0, 25)
                        : template?.filter_template_name}
                    </strong>
                  </span>
                </span>
              </Tooltip>
              <Tooltip
                overlayStyle={{
                  width: "18rem",
                }}
                color="#3B5175"
                title={
                  <div
                    className="custom_scroll"
                    style={{
                      maxWidth: "27rem",
                      maxHeight: "23rem",
                      overflow: "auto",
                      scrollBehavior: "smooth",
                    }}
                  >
                    <div className="mb-1">
                      <div className="mb-2">
                        <p className="mb-0 pb-0 text-white">
                          Remove the quick filter
                        </p>
                      </div>
                    </div>
                  </div>
                }
                placement="rightTop"
              >
                <div
                  className={
                    selectedPill[0]?.filter_template_id ===
                    template?.filter_template_id
                      ? "close-icon-pill"
                      : ""
                  }
                  onClick={() => handlePillDetails(template)}
                >
                  {selectedPill[0]?.filter_template_id ===
                    template?.filter_template_id && (
                    <CloseCircleOutlined
                      className="QuickFilterList__cloaseIcon"
                      // style={{ fontSize: "2rem", color: "#3b5175" }}
                    />
                  )}
                </div>
              </Tooltip>
            </div>
          ))}
        </div>
      ) : (
        ""
      )}
      {isModalShow && (
        <DeleteWidget
          isModalShow={isModalShow}
          handleChange={handleChange}
          modalText={modalText}
        />
      )}
      {isModalShare && (
        <ShareModal
          isModalShare={isModalShare}
          handleChangeShare={handleChangeShare}
          isModalSaveAndShare={isModalSaveAndShare}
        />
      )}
      {isPdfModalOpen && (
        <PdfModal
          onSubmitOk={handleSchedulePdf}
          totalPdfWidgets={totalPdfWidgets}
          unsupportedPdfWidgets={unsupportedPdfWidgets}
          setAiInsightModal={setAiInsightModal}
        />
      )}
      {aiInsightModal && workspace_privileges?.ai_insights_ppt_pdf && (
        <ModalAI
          onSubmitOk={handleSchedulePdf}
          aiInsightModal={aiInsightModal}
          setAiInsightModal={setAiInsightModal}
        />
      )}
      {isPPTModalOpen && (
        <ErrorBoundary>
          <ModalPpt isModalOpen={isPPTModalOpen} />
        </ErrorBoundary>
      )}
      {/* Save As Modal */}
      {duplicateDashboardFlag && (
        <SaveAsModal
          isModalSaveAs={isModalSaveAs}
          setIsModalSaveAs={setIsModalSaveAs}
          handleChangeShare={handleChangeShare}
        />
      )}
      {/* Save Dashboard Modal */}
      {saveDashboardModalFlag && (
        <SaveDashboardModal
          isModalShow={saveDashboardModalFlag}
          setIsModalSaveAs={setIsModalSaveAs}
        />
      )}

      {/* Save Edited Dashboard Modal */}
      {saveEditedDashboardModalFlag && (
        <SaveEditedDashboardModal
          isModalShow={saveEditedDashboardModalFlag}
          // setIsModalSaveAs={setIsModalSaveAs}
        />
      )}

      {/* Restored Dashboard Modal */}
      {restoredDashboardModal && (
        <RestoreDashboardModal
          isModalShow={restoredDashboardModal}
          setRestoredDashboardModal={setRestoredDashboardModal}
          restroreDashboardFunction={restroreDashboardFunction}
        />
      )}

      <ErrorBoundary>
        {visible && (
          <FilterDrawer
            onClose={removeFilterPanel}
            setfilterSearch={setfilterSearch}
            filterSearch={filterSearch}
            filterClearTrigger={filterClearTrigger}
            setfilterClearTrigger={setfilterClearTrigger}
            drawer={true}
            type="global_dashboard"
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            selectQuickFilter={selectQuickFilter}
            setSelectedTemplatePill={setSelectedTemplatePill}
            selectedTemplatePill={selectedTemplatePill}
          />
        )}
      </ErrorBoundary>
      {/* {isDashboardScheduleModal && (
        <Suspense
          fallback={
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
                height: "calc(100vh - 4rem)",
              }}
            >
              <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          }
        >
          <ErrorBoundary>
            <ScheduleReportIndex
              templateId={isDashboardScheduleTemplate?.template_id}
              isModalSchedule={isDashboardScheduleModal}
            />
          </ErrorBoundary>
        </Suspense>
      )} */}
    </>
  );
};

export default React.memo(Header);
